import React, { useContext, useEffect, useState } from 'react';
import { MdSearch } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

import { Box, Grid2 } from '@mui/material';
import api, { authHeader } from '../../../../services/API/apiConfig';
import { ConstructionCard } from '../../../components/singleComponents/cards/ConstructionCard';
import { DialogBox } from '../../../components/singleComponents/dialogs/DialogBox';
import { Header } from '../../../components/singleComponents/headers';
import ToasterBox from '../../../components/singleComponents/toaster/ToasterBox';

import { orderArrayAlphabetically } from '../../../../services/auxiliaryFunctions/functions';
import {
  BtnStyled,
  ButtonInputStyled,
  MiddleOfThePageStyled,
  RootStyled,
  SearchAndFilterStyled,
  SearchStyled,
  SeeMoreStyled,
  TextFieldStyled,
} from './ConstructionAdmin.styles';

import { TourContext } from '../../../../context/tour';

export function ConstructionAdmin() {
  const navigate = useNavigate();

  const { tutorialStep, setTutorialStep } = useContext(TourContext);

  const [constructions, setConstructions] = useState([]);
  const [filteredConstructions, setFilteredConstructions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [seeMore, setSeeMore] = useState(11);
  const [openDialog, setOpenDialog] = useState(false);
  const [constructionId, setConstructionId] = useState(null);
  const [successSubmit, setSuccessSubmit] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const goToConstructionsDetails = (id) => {
    navigate(`/constructions/${id}`);
  };

  const handleGoToNewConstruction = () => {
    navigate('/new-construction');
  };

  const handleDeleteConstruction = async (id) => {
    await api
      .delete(`/constructions/${id}`, {
        headers: authHeader(),
      })
      .then(() => {
        setOpenDialog(!openDialog);
        setSuccessMessage('Obra removida com sucesso');
        setSuccessSubmit(true);
        setTimeout(() => {
          setSuccessSubmit(false);
          window.location.reload();
        }, 1500);
      });
  };

  const sortConstructions = (data) => {
    const orderedConstructions = orderArrayAlphabetically(data);

    const onGoingConstructions = orderedConstructions.filter(
      ({ status }) => status === 'Em andamento'
    );
    const finishedConstructions = orderedConstructions.filter(
      ({ status }) => status !== 'Em andamento'
    );

    return [...onGoingConstructions, ...finishedConstructions];
  };

  useEffect(() => {
    if (tutorialStep < 7) {
      setTutorialStep(7);
    }
  }, []);

  useEffect(() => {
    const getConstructions = () => {
      api
        .get('/constructions', {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;
          const sortedConstructions = sortConstructions(data);
          setConstructions(sortedConstructions);
          setFilteredConstructions(sortedConstructions);
        });
    };

    if (searchTerm === '') {
      getConstructions();
    } else {
      setFilteredConstructions(
        constructions.filter(
          ({ name, address, status, users }) =>
            name?.toLowerCase().includes(searchTerm.toLowerCase().trim()) ||
            address?.toLowerCase().includes(searchTerm.toLowerCase().trim()) ||
            status?.toLowerCase().includes(searchTerm.toLowerCase().trim()) ||
            (users.length &&
              users[0].name
                .toLowerCase()
                .includes(searchTerm.toLowerCase().trim()))
        )
      );
    }
  }, [searchTerm]);

  return (
    <>
      <Header page="Obras" />
      <RootStyled>
        {successSubmit && <ToasterBox message={successMessage} />}
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <MiddleOfThePageStyled item>
            <BtnStyled
              id="form-button"
              color="secondary"
              variant="contained"
              onClick={handleGoToNewConstruction}
            >
              Cadastrar Obra
            </BtnStyled>
            <SearchAndFilterStyled>
              <SearchStyled id="search-bar">
                <TextFieldStyled
                  type="search"
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Pesquisar por obra"
                />
                <ButtonInputStyled variant="contained">
                  <MdSearch size={13} />
                </ButtonInputStyled>
              </SearchStyled>
            </SearchAndFilterStyled>
          </MiddleOfThePageStyled>
          <Grid2 container direction="row" spacing={4} id="constructions-box">
            {filteredConstructions.map(
              (construction, index) =>
                index <= seeMore && (
                  <ConstructionCard
                    key={construction.id}
                    id={construction.id}
                    status={construction.status}
                    name={construction.name}
                    facade={construction?.path?.url}
                    setOpenDialog={setOpenDialog}
                    constructionId={constructionId}
                    setConstructionId={setConstructionId}
                    goToConstructionDetails={goToConstructionsDetails}
                  />
                )
            )}
          </Grid2>
          {seeMore < filteredConstructions.length - 1 && (
            <SeeMoreStyled
              variant="contained"
              onClick={() => setSeeMore((prev) => prev + 8)}
              style={{ width: '22em', margin: '40px auto 0 auto' }}
            >
              VER MAIS
            </SeeMoreStyled>
          )}
        </Box>
        <DialogBox
          title="Remover obra"
          content="Deseja realmente remover esta obra? Todas as informações inseridas serão perdidas."
          openDialog={openDialog}
          closeDialog={() => setOpenDialog(!openDialog)}
          mainAction={() => handleDeleteConstruction(constructionId)}
        />
      </RootStyled>
    </>
  );
}
